import Model from "./base/model";

class Customer extends Model{
  resourceName() {
    return "customers";
  }

  fields() {
    return {
      social_reason: "",
      fantasy_name:"",
      cnpj: "",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "addresses" },
      shippers: {jsonApi: "hasMany", type: "shippers"}
    };
  }

  async search(data) {
    return this.request(
      this.resourceName() + "/search",
      "POST",
      {include:"address"},
      data
    );
  }
}

export default new Customer();
